// Copyright (C) 2021 Bystronic Laser AG

import {
  CareAlertMetric,
  AlertOperator,
  AlertSeverity,
} from './enums/AlertsEnums';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';


/**
 * Alert template definition to be applied to devices (just with fields needed
 * for the list).
 *
 * Created by Global eService users to be applied afterward to devices. A Preset
 * alert is created from it when applied to a device.
 */
export interface StandardAlertListItem {
  // "Number" in the UI
  id: number;
  status: StandardAlertStatus;
  severity: AlertSeverity;
  name: string;
  // KPI
  metric: CareAlertMetric;
  operator: AlertOperator;
  threshold: number;
  dateGrouping: FilterTimeAxisSpanEnum;
  eventSources: string[];
  eventCodes: string[];
  variable: string | undefined;
}

/**
 * Alert template definition to be applied to devices (with additional fields
 * needed for the detail).
 */
export interface StandardAlert extends StandardAlertListItem {
  description: string | null;
  deactivationDate: Date | null;
  deactivatedBy: string | null;
  createdBy: string;
  modifiedBy: string;
  modifiedDate: Date;
}

/**
 * Statuses for standard alerts.
 *
 * Depends on the status of its derived preset alerts.
 */
export enum StandardAlertStatus {
  /**
   * No derived preset alerts applied to any device yet.
   *
   * Default status when created. */
  Draft = 1,

  /** Derived preset alert applied to some device but not triggered. */
  Active = 2,

  /** Some derived preset alert has been triggered. */
  InUse = 3,

  /** No longer detecting (soft deletion). */
  Inactive = 4,
}

export interface StandardAlertEligibleDevice {
  id: number;
  customerName: string;
  subsidiaryName: string;
  equipmentNumber: string;
  name: string;
  model: string;
}

export const nullStandardAlert: StandardAlert = Object.freeze({
  id: 0,
  status: StandardAlertStatus.Inactive,
  name: '',
  description: null,
  severity: AlertSeverity.Low,
  metric: CareAlertMetric.DrawerChanges,
  operator: AlertOperator.Equal,
  threshold: 0,
  dateGrouping: FilterTimeAxisSpanEnum.Day,
  variable: undefined,
  eventSources: [],
  eventCodes: [],
  deactivationDate: null,
  deactivatedBy: null,
  createdBy: '',
  modifiedBy: '',
  modifiedDate: new Date(),
});

